import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { getRouteApi } from '@tanstack/react-router';
import { useMemo } from 'react';

import { createClient } from '@/utils';

export type UseClientOpts = object;

const authRoute = getRouteApi('/_auth');

// eslint-disable-next-line no-empty-pattern
export const useClient = ({}: UseClientOpts = {}) => {
  const auth = useKindeAuth();
  const { organizationId } = authRoute.useLoaderData();
  const client = useMemo(() => createClient(auth, organizationId), [auth, organizationId]);

  return { client: client };
};
